import { Injectable } from '@angular/core';
import { EnvDomainVariables } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class EnvCdssDevService {
  getDomainInfo(): EnvDomainVariables {
    return {
      _enableErrorLogging: false,
      _enableRefreshToken: true,
      isMagellan: '0',
      _env: 'cdss-dev',
      _apiUrl: 'https://dev3-api.p-cis.com/api/',
      _production: true,
      _redirectUri: 'https://dev3-login.p-cis.com/',
      _responseType: 'token id_token',
      _issuer: 'https://cdssdevadb2c.b2clogin.com/7ab5a94a-cb70-473b-a029-badbd9e113eb/v2.0/',
      _strictDiscoveryDocumentValidation: false,
      _tokenEndpoint: 'https://cdssdevadb2c.b2clogin.com/cdssdevadb2c.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1_signin',
      _loginUrl: 'https://cdssdevadb2c.b2clogin.com/cdssdevadb2c.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_Signin',
      _clientId: '6e147d55-c9e3-4bef-9390-6cbf8959d9a1',
      _scope: 'openid profile https://cdssdevadb2c.onmicrosoft.com/api/cdss.read',
      _skipIssuerCheck: true,
      _clearHashAfterLogin: true,
      _oidc: true,
      _logoutUrl: 'https://cdssdevadb2c.b2clogin.com/cdssdevadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/logout?post_logout_redirect_uri=https://dev3-login.p-cis.com/',
      _signInURL: 'https://cdssdevadb2c.b2clogin.com/cdssdevadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_signin_signup_frp',
      _signInURLSSO: 'https://cdssdevadb2c.b2clogin.com/cdssdevadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO',
      _adb2cTenantUrl: 'https://cdssdevadb2c.b2clogin.com/cdssdevadb2c.onmicrosoft.com/oauth2/v2.0/',
      _magicLink: 'https://cdssdevadb2c.b2clogin.com/cdssdevadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_WITH_EMAIL',
      _oktaClientId: '0oagg12mndCCqewgf4h7',
      _oktaIssuer: 'https://login.5.cares.cwds.ca.gov/oauth2/ausgg1e5uvhU9Fvmo4h7',
      _oktaRedirectUri: 'https://dev3-login.p-cis.com/auth/okta/callback',
      _authEndpoint: 'https://cdssdevadb2c.b2clogin.com/cdssdevadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/authorize',
      _magicLinkScope : 'https://cdssdevadb2c.b2clogin.com/cdssdevadb2c.onmicrosoft.com/B2C_1A_SIGNIN_WITH_EMAIL/oauth2/v2.0/authorize',
      _launchDarklyClientId: '69120006711aa209b78d9ab0',
      _intercomAppId: 'bqgvwybf'
    };
  }
}
